export default __webpack_public_path__ + "static/media/facebook.c8392c22.webp";